// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2738":"a38c4c4b","3091":"a38c4c4b","7699":"a38c4c4b"}[chunkId] + ".chunk.css";
};